import type { ThemePreset, ThemeName } from './types';

export const themes: ThemePreset[] = [
  {
    name: 'neon', label: 'Neon',
    bg: '#08080f', bgGrad: 'rgba(15, 5, 30, 1)',
    accent: '#00ff88', accentRgb: '0, 255, 136',
    shapeAlpha: 0.4, glowIntensity: 1.5, colorShift: 0,
  },
  {
    name: 'pastel', label: 'Pastel',
    bg: '#1a1520', bgGrad: 'rgba(30, 20, 35, 1)',
    accent: '#ff6b9d', accentRgb: '255, 107, 157',
    shapeAlpha: 0.38, glowIntensity: 0.6, colorShift: 30,
  },
  {
    name: 'mono', label: 'Mono',
    bg: '#0a0a0a', bgGrad: 'rgba(12, 12, 12, 1)',
    accent: '#ffffff', accentRgb: '255, 255, 255',
    shapeAlpha: 0.35, glowIntensity: 0.8, colorShift: 0,
  },
  {
    name: 'sunset', label: 'Sunset',
    bg: '#1a0a2e', bgGrad: 'rgba(25, 10, 40, 1)',
    accent: '#ff6b35', accentRgb: '255, 107, 53',
    shapeAlpha: 0.4, glowIntensity: 1.2, colorShift: -60,
  },
  {
    name: 'ocean', label: 'Ocean',
    bg: '#0a1628', bgGrad: 'rgba(10, 22, 40, 1)',
    accent: '#00d4ff', accentRgb: '0, 212, 255',
    shapeAlpha: 0.38, glowIntensity: 1.0, colorShift: 180,
  },
];

let currentTheme: ThemePreset = themes[0];

export function getCurrentTheme(): ThemePreset {
  return currentTheme;
}

export function setTheme(name: ThemeName): ThemePreset {
  const found = themes.find(t => t.name === name);
  if (found) {
    currentTheme = found;
    applyThemeVars(found);
  }
  return currentTheme;
}

export function applyThemeVars(theme: ThemePreset): void {
  const root = document.documentElement;
  root.style.setProperty('--bg-dark', theme.bg);
  root.style.setProperty('--accent', theme.accent);
  root.style.setProperty('--accent-rgb', theme.accentRgb);
  root.style.setProperty('--glass-bg', `${theme.bg}aa`);
}
